export const isActionValid = (invalidAction: any) => {
        const actionInvalidFieldNames= Object.keys(invalidAction)
        const hasInvalidFieldsInAction = !!actionInvalidFieldNames.length

        return !hasInvalidFieldsInAction
}
